import React, { useEffect } from "react";
import "./About2.css";
import aboutimg1 from "../images/goal.jpg";

const About2 = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll(".about2 .animate-side");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="about2" id="about2">
      <div className="content1-2">
        <div className="content2">
          <h1 className="about-title animate-side slide-left row-0">
            What is the goal <br />
            <span id="p1">of Dataharbor?</span>
          </h1>

          <p className="animate-side slide-right row-1">
            Dataharbor exists to give businesses of all sizes the technological 
            edge they need to thrive in a digital-first economy. By offering an 
            integrated suite of services—from ERP and e-commerce to bespoke system 
            development—we strive to be the single, reliable technology partner that 
            helps our clients automate workflows, connect with customers, and drive 
            sustainable growth.
          </p>
        </div>

        <div className="image1 animate-side slide-left row-2">
          <img className="img2" src={aboutimg1} alt="Dataharbor ERP goal illustration" />
        </div>
      </div>
    </div>
  );
};

export default About2;